<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="titleColor text-2xl font-bold" i18n="@@cities">Cities</h1>
    <a
      [routerLink]="['/admin/cities', cityId(), 'create-new-city']"
      class="primaryButton ml-[10px] flex items-center justify-center gap-1 rounded-[8px] px-[10px] py-[5px] text-[13px] font-[500] hover:cursor-pointer">
      <app-add-icon />

      <span i18n="@@addcity">Add city</span>
    </a>
  </div>
</div>
<div class="mb-4 rounded-2xl p-4">
  <app-cities-list-component />
</div>
